






























































































































































































































































import { NewsManagementNewsService as newsApi } from "@/common/api";
import { LANG } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import QEditor from "@/components/common/qEditor.vue";
import QLanguageBox from "@/components/common/qLanguageBox.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import QUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import {
  CATEGORIES,
  CATEGORIES_KEY,
  SETTING,
  STATUS,
  STATUS_ARRAY_INPUT,
} from "@/model/news";
import { DEFAULT_IMAGE_KEYS, DEFAULT_IMAGES } from "@/model/news";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "NewsEditComponent",
  components: {
    QEditor,
    QReleaseSetting,
    QLanguageTab,
    QLanguageBox,
    QCalendar,
    QErrors,
    QUploadSingleImage,
  },
})
export default class NewsEditComponent extends Vue {
  public title = "お知らせの新規作成";
  public categories = CATEGORIES;
  public statusList = STATUS_ARRAY_INPUT;
  public languages = [LANG.EN, LANG.CN];
  public contextLang = LANG.JA;

  public readonly RELEASE_NOW = SETTING.NOW;
  public readonly RELEASE_DATE = SETTING.DATE;
  public newsId = null;

  public errors = {};

  public form: any = {
    category: CATEGORIES_KEY.CATEGORY_NEWS,
    title: "",
    title_en: "",
    title_cn: "",
    is_upload_thumbnails: false,
    thumbnail_no: DEFAULT_IMAGE_KEYS.IMAGE_1,
    image_id: "",
    image: "",
    thumbnail_name: "",
    context: "",
    context_en: "",
    context_cn: "",
    open_status: STATUS.EDIT,
    release_setting: null,
    post_date: null,
  };
  public postDate = null;
  public originalForm;

  public uploading = false;
  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png",
    maxFilesize: 5, // 5mb
  };

  get contextLangList() {
    return [...[LANG.JA], ...this.languages];
  }

  get defaultThumbnail() {
    return DEFAULT_IMAGES;
  }

  public async mounted() {
    this.newsId = this.$router.currentRoute.params?.id;

    if (this.newsId) {
      await this.getDetail();
      this.title = `${this.form.title} の編集`;
    }

    this.originalForm = { ...this.form };

    if (!this.form.title_cn && !this.form.context_cn) {
      const index = this.languages.indexOf(LANG.CN);
      this.languages.splice(index, 1);
    }
  }

  public async getDetail() {
    const result = await newsApi.adminNewsShow({
      id: this.newsId,
    });

    this.form = result.data.news;
    this.postDate = this.form.post_date;

    if (
      this.form.open_status === STATUS.RELEASE &&
      moment(this.form.post_date).isBefore(moment())
    ) {
      this.form.release_setting = this.RELEASE_NOW;
      this.form.post_date = null;
    }

    if (this.form.post_date) {
      this.form.post_date = moment(this.form.post_date).format(
        "YYYY-MM-DD HH:mm",
      );
    }
  }

  public async submit() {
    const parameters = { ...this.form };
    let result;
    try {
      if (!this.languages.includes("en")) {
        parameters.title_en = null;
        parameters.context_en = null;
      }
      if (!this.languages.includes("cn")) {
        parameters.title_cn = null;
        parameters.context_cn = null;
      }

      result = this.newsId
        ? await newsApi.adminNewsEdit({
          ...parameters,
          ...{ id: this.newsId },
        })
        : await newsApi.adminNewsCreate(parameters);
      QNotify.success({
        text: this.newsId
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.$router.push({ name: "admin.news.index" });
    } catch (error: any) {
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
      if ("context" in this.errors) {
        this.contextLang = LANG.JA;
      } else if ("context_en" in this.errors) {
        this.contextLang = LANG.EN;
      } else if ("context_cn" in this.errors) {
        this.contextLang = LANG.CN;
      }
    }
  }

  public changeTypeRelease() {
    this.form = { ...this.form, release_setting: this.form.release_setting };

    if (this.form.release_setting == this.RELEASE_DATE) {
      const date = new Date();
      const minutes = date.getMinutes();
      let hours = date.getHours();
      let defaultMinute = "00";

      if (minutes > 0 && minutes <= 15) {
        defaultMinute = "15";
      } else if (minutes > 15 && minutes <= 30) {
        defaultMinute = "30";
      } else if (minutes > 30 && minutes <= 45) {
        defaultMinute = "45";
      } else if (minutes > 45) {
        hours++;
      }
      this.form.post_date = moment().format(
        "YYYY-MM-DD " + hours + ":" + defaultMinute,
      );
    } else if (this.form.release_setting == this.RELEASE_NOW) {
      this.form.post_date = null;
    }
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await newsApi.adminNewsDelete({
            id: this.newsId,
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.$router.push({ name: "admin.news.index" });
        } catch (error) {
          message = error.body.message;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cancel() {
    // check modifier form.
    const diff = compareWithKeys(this.form, this.originalForm, [
      "category",
      "title",
      "title_en",
      "title_cn",
      "context",
      "context_en",
      "context_cn",
      "open_status",
      "post_date",
      "release_setting",
    ]);

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.$router.push({ name: "admin.news.index" });
        },
      });
    } else {
      this.$router.push({ name: "admin.news.index" });
    }
  }

  public addOrRemoveLang(value: string) {
    const index = this.languages.indexOf(value);

    if (index === -1) {
      this.languages.push(value);
    } else {
      this.languages.splice(index, 1);
    }
  }

  public async preview() {
    const form = { ...this.form };
    form.post_date = this.postDate
      ? moment(this.postDate).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    form.updated_at = form.updated_at
      ? moment(form.updated_at).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    localStorage.setItem("news", JSON.stringify(form));
    const previewRoute = this.$router.resolve({ name: "admin.news.preview" });
    window.open(previewRoute.href, "_blank");
  }

  public getDefaultThumbnailUrl(name) {
    return "/images/default/" + name;
  }

  public changeFile(file) {
    this.form.image_id = file ? file.id : null;
    this.form.image = {
      id: file ? file.id : null,
      name: file ? file.filePath : null,
    };
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public changeThumbnailSetting() {
    if (!this.form.is_upload_thumbnails) {
      this.form.thumbnail_no = DEFAULT_IMAGE_KEYS.IMAGE_1;
    } else {
      this.form.thumbnail_no = null;
    }
  }
}
